import React, { useRef, useState } from "react";
import { Button } from "@/components/ui/button";

/**
 * Simple image annotator — click to place labeled markers (percent coords).
 */
export function StepAnnotator({ photoUrl, annotations = [], onChange }) {
  const [label, setLabel] = useState("");
  const boxRef = useRef(null);

  const onClick = (e) => {
    if (!boxRef.current || !label.trim()) return;
    const rect = boxRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    onChange([...(annotations || []), { type: "marker", x, y, w: 12, h: 6, label: label.trim() }]);
    setLabel("");
  };

  if (!photoUrl) {
    return (
      <div className="text-sm text-[#5B6472]">
        Add a photo URL on the step, then annotate with markers.
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="step-annotator">
      <div className="flex gap-2">
        <input
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          placeholder="Marker label, then click image"
          className="flex-1 rounded-full bg-white/[0.04] border border-white/10 px-4 py-2 text-sm text-white"
        />
        <Button
          type="button"
          className="btn-ghost-glass rounded-full"
          onClick={() => onChange([])}
        >
          Clear
        </Button>
      </div>
      <div
        ref={boxRef}
        className="relative rounded-2xl overflow-hidden border border-white/10 cursor-crosshair bg-black/40"
        onClick={onClick}
      >
        <img src={photoUrl} alt="" className="w-full max-h-72 object-contain" />
        {(annotations || []).map((a, i) => (
          <div
            key={i}
            className="absolute border border-cyan-400 bg-cyan-500/20 text-[10px] text-white px-1 rounded"
            style={{ left: `${a.x}%`, top: `${a.y}%` }}
          >
            {a.label}
          </div>
        ))}
      </div>
    </div>
  );
}
